import React, { useEffect, useState } from "react";
import FraudScoreChart from "./FraudScoreChart";
import styles from "./FraudScore.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import useCommonStore from "../../../../stores/common";

function FraudScore({ data }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);

  return (
    <div
      className={`${styles.fraud_score} ${expandAppDetails ? styles.expanded : ""} `}
    >
      {data ? (
        <>
          <div className={styles.score}>
            <div className={styles.fraud_score_chart_sec}>
              <FraudScoreChart
                score={
                  data?.content?.score?.risk ? data?.content?.score?.risk : 0
                }
              />
              <div>
                <h6>Very high risk</h6>
                <p>
                  {" "}
                  <span>{data?.content?.score?.risk} </span> risk
                </p>
              </div>
            </div>

            <div className={styles.data_blocks}>
              {data?.content?.area !== null &&
                typeof data?.content?.area === "object" &&
                Object.entries(data?.content?.area).length > 0 && (
                  <>
                    {Object.entries(data?.content?.area).map(
                      ([label, score], index) => (
                        <div key={index} className={styles.data_item}>
                          <div className={styles.block_content}>
                            <p>{score}</p>
                            <p>{label}</p>
                          </div>
                        </div>
                      ),
                    )}
                  </>
                )}
            </div>
          </div>

          <div className={styles.data_section}>
            {/* Domains */}
            <HeadingWithLine text={"Domain"} className={styles.heading} />
            <div className={styles.data_matrix}>
              {data?.content?.domain !== null &&
                typeof data?.content?.domain === "object" &&
                Object.entries(data?.content?.domain).length > 0 && (
                  <>
                    {Object.entries(data?.content?.domain).map(
                      ([label, score], index) => (
                        <div key={index} className={styles.data_matrix_item}>
                          <p>{label}</p>
                          <p>{score ? score : "-"}</p>
                        </div>
                      ),
                    )}
                  </>
                )}
            </div>

            {/* Risk Hits */}
            <HeadingWithLine text={"risk_hits"} className={styles.heading} />
            <div className={styles.data_matrix}>
              {data?.content?.risk_hits !== null &&
                typeof data?.content?.risk_hits === "object" &&
                Object.entries(data?.content?.risk_hits).length > 0 && (
                  <>
                    {Object.entries(data?.content?.risk_hits).map(
                      ([label, items], index) => (
                        <div key={index} className={styles.data_matrix_item}>
                          <p>{label}</p>
                          <p>
                            {items.map((item) => (
                              <React.Fragment key={item}>
                                {item}. <br />
                              </React.Fragment>
                            ))}
                          </p>
                        </div>
                      ),
                    )}
                  </>
                )}
            </div>

            {/* emaildomain */}
            <HeadingWithLine text={"emaildomain"} className={styles.heading} />
            <div className={styles.email_domain}>
              <div className={styles.data_matrix}>
                {data?.content?.emaildomain !== null &&
                  typeof data?.content?.emaildomain === "object" &&
                  Object.entries(data?.content?.emaildomain).length > 0 && (
                    <>
                      {Object.entries(data?.content?.emaildomain).map(
                        ([label, score], index) => (
                          <div key={index} className={styles.data_matrix_item}>
                            <p>{label}</p>
                            <p>{score ? score : "-"}</p>
                          </div>
                        ),
                      )}
                    </>
                  )}
              </div>
            </div>

            {/* IP_location */}
            <HeadingWithLine text={"IP_location"} className={styles.heading} />
            <div className={styles.data_matrix}>
              <div className={styles.data_matrix}>
                {data?.content?.ip_location !== null &&
                  typeof data?.content?.ip_location === "object" &&
                  Object.entries(data?.content?.ip_location).length > 0 && (
                    <>
                      {Object.entries(data?.content?.ip_location).map(
                        ([label, score], index) => (
                          <div key={index} className={styles.data_matrix_item}>
                            <p>{label}</p>
                            <p>{score ? score : "-"}</p>
                          </div>
                        ),
                      )}
                    </>
                  )}
              </div>
            </div>

            {/* Combo_Details */}
            <HeadingWithLine
              text={"Combo_Details"}
              className={styles.heading}
            />
            <div className={styles.combo_details}>
              <div className={styles.data_matrix}>
                <div className={styles.data_matrix_item}>
                  <p>status</p>
                  <p>{data?.content?.status || "0"}</p>
                </div>

                <div className={styles.data_matrix_item}>
                  <p>version</p>
                  <p>{data?.content?.version || "-"}</p>
                </div>

                <div className={styles.data_matrix_item}>
                  <p>transaction_id</p>
                  <p>{data?.content?.transaction_id || "-"}</p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.no_data}>
          <h6>No data to display</h6>
        </div>
      )}
    </div>
  );
}

export default FraudScore;
